import React from 'react'
import { makeStyles } from '@mui/styles'
import { Box, Typography } from '@mui/material'
import { Carousel } from 'react-responsive-carousel'
// eslint-disable-next-line
import styles from 'react-responsive-carousel/lib/styles/carousel.min.css'
import Asos from './partners/Asos.png'
import AstraZeneca from './partners/AstraZeneca.png'
import BBC from './partners/BBC.png'
import Booking from './partners/Booking.png'
import Burberry from './partners/Burberry.png'
import MLB from './partners/MLB.png'
import PrincesGroup from './partners/PrincesGroup.png'
import RollsRoyce from './partners/RollsRoyce.png'
import RSPCA from './partners/RSPCA.png'
import Tesco from './partners/Tesco.png'
import VirginMoney from './partners/VirginMoney.png'

const partnersList = [
  { src: Asos, alt: 'Asos' },
  { src: AstraZeneca, alt: 'AstraZeneca' },
  { src: BBC, alt: 'BBC' },
  { src: Booking, alt: 'Booking.com' },
  { src: Burberry, alt: 'Burberry' },
  { src: MLB, alt: 'MLB' },
  { src: PrincesGroup, alt: 'Princes Group' },
  { src: RollsRoyce, alt: 'Rolls Royce' },
  { src: RSPCA, alt: 'RSPCA' },
  { src: Tesco, alt: 'Tesco' },
  { src: VirginMoney, alt: 'Virgin Money' }
]

export const useStyles = makeStyles(({ palette, spacing, typography }) => ({
  carousel: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: spacing(1),
    maxWidth: '220px'
  },
  carouselImageContainer: {
    backgroundColor: palette.common.white,
    borderRadius: spacing(1)
  },
  carouselImage: {
    display: 'flex',
    alignItems: 'center',
    padding: spacing(4),
    maxWidth: '220px',
    minHeight: '110px',
    maxHeight: '110px'
  }
}))

const PaywallCarousel = () => {
  const classes = useStyles()

  return (
    <Box className={classes.carousel}>
      <Typography textAlign='center'>
        Trusted By
      </Typography>
      <Box className={classes.carouselImageContainer}>
        <Carousel
          showArrows={false}
          showStatus={false}
          showIndicators={false}
          showThumbs={false}
          useKeyboardArrows={false}
          swipeable={false}
          autoPlay
          infiniteLoop
          centerMode
          interval={3000}
          transitionTime={500}
          width='220px'
          centerSlidePercentage={100}
        >
          {partnersList.map((partner, index) => (
            <Box key={index} className={classes.carouselImage}>
              <img src={partner.src} alt={partner.alt} />
            </Box>
          ))}
        </Carousel>
      </Box>
    </Box>

  )
}

export default PaywallCarousel
